import {defineMessages} from 'react-intl';

export const propertyTypesMessagesPlural = defineMessages({
    property_type_all: {
        id: 'property_type_all',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_apartment: {
        id: 'property_type_apartment',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_barn: {
        id: 'property_type_barn',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_boat: {
        id: 'property_type_boat',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_bungalow: {
        id: 'property_type_bungalow',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_cabin: {
        id: 'property_type_cabin',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_caravane: {
        id: 'property_type_caravane',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_castle: {
        id: 'property_type_castle',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_chalet: {
        id: 'property_type_chalet',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_chambre: {
        id: 'property_type_chambre',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_chateau: {
        id: 'property_type_chateau',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_condo: {
        id: 'property_type_condo',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_cottage: {
        id: 'property_type_cottage',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_countryhouse: {
        id: 'property_type_countryhouse',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_estate: {
        id: 'property_type_estate',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_farmhouse: {
        id: 'property_type_farmhouse',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_house: {
        id: 'property_type_house',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_houseboat: {
        id: 'property_type_houseboat',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_lodge: {
        id: 'property_type_lodge',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_mill: {
        id: 'property_type_mill',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_mobile_home: {
        id: 'property_type_mobile_home',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_resort: {
        id: 'property_type_resort',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_studio: {
        id: 'property_type_studio',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_suite: {
        id: 'property_type_suite',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_tower: {
        id: 'property_type_tower',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_townhome: {
        id: 'property_type_townhome',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_villa: {
        id: 'property_type_villa',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_yacht: {
        id: 'property_type_yacht',
        defaultMessage: 'UNTRANSLATED'
    }
});

export const propertyTypesMessagesSingular = defineMessages({
    property_type_all_singular_with_article: {
        id: 'property_type_all_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_apartment_singular_with_article: {
        id: 'property_type_apartment_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_barn_singular_with_article: {
        id: 'property_type_barn_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_boat_singular_with_article: {
        id: 'property_type_boat_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_bungalow_singular_with_article: {
        id: 'property_type_bungalow_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_cabin_singular_with_article: {
        id: 'property_type_cabin_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_caravane_singular_with_article: {
        id: 'property_type_caravane_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_castle_singular_with_article: {
        id: 'property_type_castle_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_chalet_singular_with_article: {
        id: 'property_type_chalet_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_chambre_singular_with_article: {
        id: 'property_type_chambre_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_chateau_singular_with_article: {
        id: 'property_type_chateau_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_condo_singular_with_article: {
        id: 'property_type_condo_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_cottage_singular_with_article: {
        id: 'property_type_cottage_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_countryhouse_singular_with_article: {
        id: 'property_type_countryhouse_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_estate_singular_with_article: {
        id: 'property_type_estate_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_farmhouse_singular_with_article: {
        id: 'property_type_farmhouse_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_house_singular_with_article: {
        id: 'property_type_house_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_houseboat_singular_with_article: {
        id: 'property_type_houseboat_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_lodge_singular_with_article: {
        id: 'property_type_lodge_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_mill_singular_with_article: {
        id: 'property_type_mill_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_mobile_home_singular_with_article: {
        id: 'property_type_mobile_home_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_resort_singular_with_article: {
        id: 'property_type_resort_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_studio_singular_with_article: {
        id: 'property_type_studio_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_suite_singular_with_article: {
        id: 'property_type_suite_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_tower_singular_with_article: {
        id: 'property_type_tower_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_townhome_singular_with_article: {
        id: 'property_type_townhome_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_villa_singular_with_article: {
        id: 'property_type_villa_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    },
    property_type_yacht_singular_with_article: {
        id: 'property_type_yacht_singular_with_article',
        defaultMessage: 'UNTRANSLATED'
    }
});

export const propertyTypesMessages = Object.assign(
    {},
    propertyTypesMessagesPlural,
    propertyTypesMessagesSingular
);
